import React, { Component, Fragment, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import lgkan from "../../assets/images/lg_kannuicon.svg"

import classnames from 'classnames';
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import scan from '../../assets/images/google-scan.png';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useTranslation, I18nextProvider } from "react-i18next";

import { changePassword } from "../../Features/Password/passwordSlice";
import { useCustomizeContext } from "../../context";
import { NumericFormat } from 'react-number-format';
import { Notify } from 'notiflix/build/notiflix-notify-aio';


import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";

import { enableTfa, disableTfa } from "../../Features/TfaSettings/tfaSettingslice";

import "react-tooltip/dist/react-tooltip.css";

import { linkEmail } from "../../Features/LinkEmail/linkEmailSlice";



const Security = (props) => {
    const { t, i18n } = useTranslation();

    let dispatch = useDispatch();

    const [tfacode, setTfaCode] = useState("");

    const [email, setEmail] = useState("");


    const [tfaEnableRes, setTfaEnableRes] = useState('');

    const [userDetailsRes, setUserDetailsRes] = useState("");

    const [oldpasswordType, setOldPasswordType] = useState("password");
    const [passwordType, setPasswordType] = useState("password");
    const [confirmpasswordType, setConfirmPasswordType] = useState("password");


    useEffect(() => {
        getuserInfo();
    }, [tfaEnableRes]);

    useEffect(() => {
        document.body.classList.remove("SideMenuOpen");
        setClassIsActive(false);
    }, []);

    const {
        loader: {
            loading, setLoading,
        },
        languageContext: {
            changeLanguageRes,
        },
        sideMenu: {
            classIsActive, setClassIsActive
        },
    } = useCustomizeContext();

    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const changePasswordSchema = yup.object().shape({
        old_password: yup.string().required(`${t('current password is required')} !`),

        new_password: yup.string().required(`${t('New Password is required')} !`)
            .matches(/^\S.*[a-zA-Z\s]*$/, `${t('First Character Whitespace Not Allowed')} !`),
        confirm_password:
            yup.string().required(`${t('Confirm password is required')} !`)
                .oneOf([yup.ref('new_password')], `${t('Password Confirm Password does not match')} !`),
    });

    const { register, handleSubmit, watch, reset, clearErrors, formState: { errors } } = useForm({
        resolver: yupResolver(changePasswordSchema),
        mode: "onBlur",
    });

    const linkEmailSchema = yup.object().shape({
        email_address: yup.string().email(`${t('Invalid Email')} !`).required(`${t('Email is required')} !`),
        password: yup.string().required(`${t('New Password is required')} !`)
            .matches(/^\S.*[a-zA-Z\s]*$/, `${t('First Character Whitespace Not Allowed')} !`),
        confirm_password:
            yup.string().required(`${t('Confirm password is required')} !`)
                .oneOf([yup.ref('password')], `${t('Password Confirm Password does not match')} !`),
    });

    const { register: register1, handleSubmit: handleSubmit1, watch: watch1, clearErrors: clearErrors1, reset: reset1, formState: { errors: errors1 } } = useForm({
        resolver: yupResolver(linkEmailSchema),
        mode: "onBlur"
    });

    const ClearErrors = () => {
        clearErrors();
        clearErrors1();
    }

    useEffect(() => {
        ClearErrors();
    }, [changeLanguageRes]);

    const onsubmit = async (data) => {
        setLoading(true);
        let res = await dispatch(changePassword(data));
        setTimeout(() => {
            if (res?.status === true) {
                setLoading(false);
                reset();
            }
            else {
                setLoading(false);
                reset();
            }
        }, 1000);
    }

    const getuserInfo = async () => {
        setLoading(true);
        let res = await dispatch(getUserDetails());
        setTimeout(() => {
            if (res?.status) {
                setUserDetailsRes(res?.data);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 1000);
    }

    const tfaFunction = async (event) => {
        event.preventDefault();
        let data = {
            "tfa_code": tfacode
        }
        if (tfacode !== "") {
            setLoading(true);
            if (userDetailsRes?.details?.randcode === "disable") {

                let res = await dispatch(enableTfa(data));
                setTimeout(() => {
                    if (res?.status === true) {
                        setLoading(false);
                        setTfaCode("");
                        setTfaEnableRes(res);
                    }
                    else {
                        setLoading(false);
                        setTfaCode("")
                    }
                }, 1000);
            }
            else {
                let res = await dispatch(disableTfa(data));
                setTimeout(() => {
                    if (res?.status === true) {
                        setLoading(false);
                        setTfaEnableRes(res);
                        setTfaCode("");
                    }
                    else {
                        setLoading(false);
                        setTfaCode("")
                    }
                }, 1000);
            }
        }
        else {
            Notify.failure(`${t('TFA code is Required')} !`, { theme: "colored", showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 });
        }
    }

    const linkEmailFunction = async (event) => {
        event.preventDefault();
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (email !== "") {
            if (email.match(mailformat)) {

            }
            else {
                Notify.failure(`${t('Invalid Email')} !`, { theme: "colored", showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 });
            }
        }
        else {
            Notify.failure(`${t('Email is required')} !`, { theme: "colored", showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 });
        }
    }

    const onsubmit1 = async (data) => {
        setLoading(true);
        let res = await dispatch(linkEmail(data));
        setTimeout(() => {
            if (res?.status) {
                setLoading(false);
                reset1();
            }
            else {
                setLoading(false);
                reset1();
            }
        }, 1000);
    }

    const showVisibilityopwd = (e) => {
        e.preventDefault();
        if (oldpasswordType === "password") setOldPasswordType("text")
        else setOldPasswordType("password");
    }
    const showVisibilitypwd = (e) => {
        e.preventDefault();
        if (passwordType === "password") setPasswordType("text")
        else setPasswordType("password");
    }

    const showVisibilitycpwd = (e) => {
        e.preventDefault();
        if (confirmpasswordType === "password") setConfirmPasswordType("text")
        else setConfirmPasswordType("password");
    }

    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">
                            <div className="securitypage-maincnt">
                                <h5 class="page-head">{t("Security")}</h5>
                                <div class="security-inrcnt">
                                    <div class="security-Tabul">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '1' })}
                                                    onClick={() => { toggle('1'); }}
                                                >
                                                    2FA
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '2' })}
                                                    onClick={() => { toggle('2'); }}
                                                >
                                                    {t("Change Password")}
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <div class="security-Tabcontent">
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="1">
                                                <div class="twofa-tabcnt">
                                                    <div class="google-auth">
                                                        <h5 class="auth-txt">{t("2FactorAuthentication(GoogleAuthenticator)")}- {userDetailsRes?.details?.randcode === "disable" ? <span>{`${t("Disabled")}`}</span> : <span style={{ color: "#faa625" }}>{`${t("Enabled")}`}</span>}</h5>
                                                        <h6 id="secreat"><span style={{ color: "#faa625" }}>{userDetailsRes?.details?.randcode === "disable" ? userDetailsRes?.details?.secret ? userDetailsRes?.details?.secret : `${t('loading')} ...` : null}</span></h6>
                                                        <p>{t("google auth message")}</p>
                                                        <div class="googleauth-input">
                                                            <div class="form-group">
                                                                <label for="">{t("Enter 2FA Code")}</label>
                                                                <NumericFormat class="form-control" allowLeadingZeros placeholder={`${t('Enter the TFA Code')}`} value={tfacode} onChange={(e) => setTfaCode(e.target.value)} />
                                                            </div>
                                                            {
                                                                userDetailsRes?.details?.randcode === "disable" ?
                                                                    <div class="qrscan-box">
                                                                        <img src={userDetailsRes?.details?.qr_code ? userDetailsRes?.details?.qr_code : scan} alt="" class="img-fluid" />
                                                                        <p class="scan-txt">{t("Scan QR Code")}</p>
                                                                    </div>
                                                                    :
                                                                    <div class="qrscan-box"></div>
                                                            }
                                                            <div class="enable-btn">
                                                                <button class="btn btn-primary" disabled={loading} onClick={(e) => tfaFunction(e)}>{userDetailsRes?.details?.randcode === "disable" ? `${t("Enable")}` : loading ? `${t('loading')} ...` : `${t('Disable')}`}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <form onSubmit={handleSubmit1(onsubmit1)} class="useForm">
                                                        <div class="email-auth">
                                                            <h5 class="auth-txt">{t("2 Factor Authentication (Email)")} </h5>
                                                            <div class="form-group mt-4">
                                                                <label for="">{t("Email")}</label>
                                                                <input type="email" autoComplete="off" name="email_address" placeholder={t("Enter the Email")} class="form-control"
                                                                    {...register1("email_address", { required: true })}
                                                                />
                                                                {errors1.email_address && (
                                                                    <span class="text-danger">{errors1.email_address.message}</span>
                                                                )}
                                                            </div>
                                                            <div class="form-group mt-4">

                                                                <label for="">{t("Password")}</label>
                                                                <div class="nd_cm_in_2 sec-2fainput">
                                                                    <input type={oldpasswordType} autoComplete="off" name="password" placeholder={t("Enter the Password")}
                                                                        class="form-control"
                                                                        {...register1("password", { required: true })}
                                                                    />

                                                                    <a className="kannu-ko" onClick={(e) => showVisibilityopwd(e)}> <img src={lgkan} alt="" /></a>



                                                                </div>
                                                                {errors1.password && (
                                                                    <span class="text-danger">{errors1.password.message}</span>
                                                                )}

                                                            </div>
                                                            <div class="form-group mt-4">
                                                                <label for="">{t("Confirm Password")}</label>
                                                                <div class="nd_cm_in_2 sec-2fainput">
                                                                    <input type={confirmpasswordType} autoComplete="off" placeholder={t("Enter the Confirm Password")}
                                                                        class="form-control"
                                                                        {...register1("confirm_password", { required: true })}
                                                                    />
                                                                    {/* <a className="kannu-ko" onClick={(e) => showVisibilityopwd(e)}> <img src={lgkan} alt="" /></a> */}
                                                                </div>
                                                                {errors1.confirm_password && (
                                                                    <span class="text-danger">{errors1.confirm_password.message}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="enable-btn">
                                                            <button class="btn btn-primary" type="submit">{t("Submit")}</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <div class="changepw-tabcnt">
                                                    <h5>{t("Change Password")}</h5>
                                                    <div class="changepw-inrform">
                                                        <form onSubmit={handleSubmit(onsubmit)}>
                                                            <div class="row useForm">
                                                                <div class="col-sm-6">
                                                                    <div class="form-group mb-0 ">
                                                                        <label for="">{t("Enter Current Password")}</label>
                                                                    </div>
                                                                    <div class="form-group nd_cm_in">
                                                                        <div class="nd_cm_in_2">
                                                                            <input type={oldpasswordType} autoComplete="off" placeholder={t("Enter the Old Password")} name="old_password" class="form-control"
                                                                                {...register("old_password", { required: true })}
                                                                            />
                                                                            <a className="kannu-ko" onClick={(e) => showVisibilityopwd(e)}> <img src={lgkan} alt="" /></a>
                                                                        </div>
                                                                        {errors.old_password && (
                                                                            <span class="text-danger">{errors.old_password.message}</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="form-group mb-0 ">
                                                                        <label for="">{t("Enter New Password")}</label>
                                                                    </div>
                                                                    <div class="form-group nd_cm_in"><div class="nd_cm_in_2">
                                                                        <input type={passwordType} autoComplete="off" placeholder={t("Enter New Password")} name="new_password" class="form-control"
                                                                            {...register("new_password", { required: true })}
                                                                        />
                                                                        <a className="kannu-ko" onClick={(e) => showVisibilitypwd(e)}> <img src={lgkan} alt="" /></a>
                                                                    </div>
                                                                        {errors.new_password && (
                                                                            <span class="text-danger">{errors.new_password.message}</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="form-group mb-0 ">
                                                                        <label for="">{t("Enter Confirm Password")}</label>
                                                                    </div>
                                                                    <div class="form-group nd_cm_in">
                                                                        <div class="nd_cm_in_2">
                                                                            <input type={confirmpasswordType} autoComplete="off" placeholder={t("Enter the Retype Password")} name="confirm_password" class="form-control"
                                                                                {...register("confirm_password", { required: true })}
                                                                            />
                                                                        </div>
                                                                        {errors.confirm_password && (
                                                                            <span class="text-danger">{errors.confirm_password.message}</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="submit-btn">
                                                                <button class="btn btn-primary" type="submit">{t("Submit")}</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </Fragment >
    );

}

export default Security;